import { SiteColors } from "../constants";
import TagBadge from "./TagBadge";

export default function SeverityTag ({severity}) {
    return (
        <TagBadge text={severity} color={SiteColors[`Severity${severity}`]} />
    )
}